import { createAction, props } from '@ngrx/store';
import { WhoAmI$Response, PasswordAuth$Response, PasswordAuth$Request } from '@api/service';

export const getUser = createAction('[App] Get user');
export const getUserFail = createAction('[App] Get user Fail', props<{ error: any }>());
export const getUserSuccess = createAction('[App] Get user Success', props<WhoAmI$Response>());

export const loginUser = createAction('[App] Login user', props<PasswordAuth$Request>());
export const loginUserFail = createAction('[App] Login user Fail', props<{ error: any }>());
export const loginUserSuccess = createAction('[App] Login user Success', props<PasswordAuth$Response>());

export const logoutUser = createAction('[App] Logout user');
export const logoutUserFail = createAction('[App] Logout user Fail', props<{ error: any }>());
export const logoutUserSuccess = createAction('[App] Logout user Success');
